export var RetailTab;
(function (RetailTab) {
    RetailTab["Grid"] = "Grid";
    RetailTab["District"] = "District";
})(RetailTab || (RetailTab = {}));
